module.exports = __webpack_public_path__ + "static/img/气韵公众号二维码.22c4d8d4.png";